export const READ_SETTINGS_SUCCEEDED = 'READ_SETTINGS_SUCCEEDED'
export const READ_SETTINGS_FAILED = 'READ_SETTINGS_FAILED'

export const UPDATE_SETTINGS_SUCCEEDED = 'UPDATE_SETTINGS_SUCCEEDED'
export const UPDATE_SETTINGS_FAILED = 'UPDATE_SETTINGS_FAILED'
